import React from 'react';
import { useTranslation } from 'react-i18next';
import ProductImage from '@stone/components/product/ProductImage';
import ProductPrice from '@stone/components/product/ProductPrice';
const ProductTileReview = (props) => {
    const { t } = useTranslation();
    const { product, color, size } = props;
    return (product && (React.createElement("div", { className: " product-tile product-tile-review product-tile-review--static" },
        React.createElement("div", { className: `product-tile-review__content image--${props.imageSize}` },
            React.createElement(ProductImage, { img: product === null || product === void 0 ? void 0 : product.imgs, type: "F" }),
            React.createElement("div", { className: "product-tile-review__info" },
                React.createElement("div", { className: "product-tile-review__info-pricetitle" },
                    React.createElement("div", null,
                        React.createElement("h3", { className: "product-tile-review__info-title" }, product.productName),
                        product.seoName && React.createElement("p", { className: "product-tile__seoname" }, product.seoName)),
                    !props.hiddenPrice && (React.createElement("div", { className: "product-tile-review__price" },
                        React.createElement(ProductPrice, { price: product.price, promotions: product.promotions })))),
                React.createElement("div", { className: "product-tile-review__info-specs" },
                    React.createElement("p", null,
                        React.createElement("span", { className: "product-tile-review__info-label" }, t('product.colorlabel')),
                        React.createElement("span", { className: "product-tile-review__info-value color" }, color === null || color === void 0 ? void 0 : color.displayValue)),
                    size && (React.createElement("p", null,
                        React.createElement("span", { className: "product-tile-review__info-label" },
                            t('label.size'),
                            ":"),
                        React.createElement("span", { className: "product-tile-review__info-value color" }, size === null || size === void 0 ? void 0 : size.displayValue)))))))));
};
ProductTileReview.defaultProps = {
    imageSize: 'large',
};
export default ProductTileReview;
